import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules/";
import VuexPersistence from "vuex-persist";

const ignoreMutations = ["loading"];

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  filter(mutation) {
    return !ignoreMutations.includes(mutation.type);
  },
  reducer(state) {
    try {
      delete state.people.loading;
      delete state.ui.loading;
      delete state.auth.message;
    } catch (e) {
      console.error(e);
    }
    return state;
  }
});
// const vuexSession = new VuexPersistence({
//   storage: window.sessionStorage
// });

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    env: {
      MSGRAPH_SHAREPOINT_SITE_ID:
        process.env.VUE_APP_MSGRAPH_SHAREPOINT_SITE_ID,
      MSGRAPH_CASE_FILES_DRIVE_ID:
        process.env.VUE_APP_MSGRAPH_CASE_FILES_DRIVE_ID,
      MSGRAPH_DOC_TEMPLATE_DRIVE_ID:
        process.env.VUE_APP_MSGRAPH_DOC_TEMPLATE_DRIVE_ID
    }
  },
  modules,
  strict: "debug",
  plugins: [vuexLocal.plugin]
});
